import { useRouter } from 'next/router';
import { useMemo } from 'react';

export interface UseRoomReturn {
  roomId: string | undefined;
  roomUrl: string;
  enabled: boolean;
}
/**
 * Helper hook to return room information.
 * roomId is automatically derived from the Next.js router.
 */
export const useDailyRoom = (): UseRoomReturn => {
  const router = useRouter();
  const roomId =
    typeof router.query.roomId === 'string' ? router.query.roomId : undefined;
  const enabled = !!roomId;

  const roomUrl = useMemo(
    () => `https://${process.env.NEXT_PUBLIC_DAILY_BS_DOMAIN}/${roomId ?? ''}`,
    [roomId],
  );

  return { roomId, roomUrl, enabled };
};
